const infoModalCopy = {
  definitions: [
    {
      heading: 'APR',
      description:
        'APR (Annual Percentage Rate) is a percentage that represents the total cost of your loan over its term, expressed as a percentage. This is a combination of your interest rate, fees and upfront costs so you can easily compare the total cost of loans.',
    },

    {
      heading: 'Rate',
      description:
        "Similar to other loans, this is how much you'll pay to borrow the money for your loan each year.",
    },
    {
      heading: 'Monthly payment',
      description:
        'This represents your monthly principal plus interest. If you choose to escrow your taxes and insurance, your total estimated monthly payment.',
    },
    {
      heading: 'Escrow account',
      description:
        'If you decide you would like to fund an escrow account at closing, please let your Loan Officer or Processor know.  After we receive documentation of your homeowners insurance policy and your title company verifies property tax amounts, we will let you know how much in additional funds are required at closing.',
    },
  ],
  disclosures: [
    {
      heading: 'Advertiser Disclosure',
      description:
        'The listings that appear on this page are from companies from which this website receives compensation, which may impact how, where and in what order products appear. This table does not include all companies or all available products. Bankrate does not endorse or recommend any companies.',
    },
  ],
}

export default infoModalCopy
